// extracted by mini-css-extract-plugin
export default {"nav__item":"MobNavItem_nav__item__lwnH8","navlink":"MobNavItem_navlink__uZs5e","navLinkActive":"MobNavItem_navLinkActive__MwdAd"};